import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => setIsOpen(!isOpen);

    const navLinks = [
        { name: 'Home', path: '/' },
        { name: 'Privacy Policy', path: '/privacy' },
        { name: 'Contact Us', path: '/contact' },
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-[#0E101D]/90 backdrop-blur-sm border-b-4 border-[#2d2d2d]' : 'bg-transparent border-b-4 border-transparent'}`}>
            <div className="container mx-auto px-4 h-20 flex justify-between items-center">
                {/* Logo */}
                <Link to="/" className="text-3xl md:text-4xl text-[#ff0055] hover:text-[#ff2266] transition-colors font-vt323 uppercase tracking-tighter" style={{ textShadow: '2px 2px 0 #fff' }}>
                    Blue<br className="hidden" />Pixelated
                </Link>

                {/* Desktop Nav */}
                <nav className="hidden md:flex space-x-8">
                    {navLinks.map((link) => (
                        <Link
                            key={link.name}
                            to={link.path}
                            className={`text-xl font-vt323 uppercase tracking-widest hover:text-[#ff0055] transition-colors ${isActive(link.path) ? 'text-[#ff0055] underline decoration-4 underline-offset-4' : 'text-white'}`}
                        >
                            {link.name}
                        </Link>
                    ))}
                </nav>

                {/* Mobile Menu Button */}
                <button onClick={toggleMenu} className="md:hidden text-white text-3xl focus:outline-none">
                    {isOpen ? <FiX /> : <FiMenu />}
                </button>
            </div>

            {/* Mobile Nav */}
            {isOpen && (
                <div className="md:hidden bg-[#0E101D] border-b-4 border-[#2d2d2d]">
                    <nav className="flex flex-col p-4 space-y-4">
                        {navLinks.map((link) => (
                            <Link
                                key={link.name}
                                to={link.path}
                                onClick={() => setIsOpen(false)}
                                className={`text-2xl font-vt323 uppercase tracking-widest hover:text-[#ff0055] transition-colors ${isActive(link.path) ? 'text-[#ff0055]' : 'text-white'}`}
                            >
                                {link.name}
                            </Link>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
};

export default Header;
